import React from 'react';
import cx from 'classnames';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  clear: () => void;
}

export default (props: Props) => {
  return (
    <div
      className={cx(style.filterButton, 'small')}
      onClick={props.clear}
      style={{
        background: colors.grayLighter,
        borderRadius: 4,
        color: colors.grayLight,
        cursor: 'pointer'
      }}
    >
      Reset
    </div>
  );
}
